import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const names = ['María L.', 'Juan C.', 'Luciana G.', 'Martín R.', 'Carolina S.', 'Diego F.', 'Valeria M.', 'Sebastián P.', 'Florencia T.', 'Nicolás B.', 'Andrea V.', 'Pablo H.', 'Romina D.', 'Facundo A.', 'Gabriela N.', 'Alejandro K.', 'Daniela O.', 'Fernando E.', 'Soledad I.', 'Gustavo W.', 'Laura Z.', 'Hernán J.', 'Natalia Q.', 'Rodrigo U.', 'Cecilia X.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná', 'San Luis', 'Corrientes', 'San Salvador de Jujuy', 'Río Cuarto', 'Tandil', 'Pergamino', 'Rafaela', 'Villa María'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 15) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    function showNotification() {
      setData({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 4000);
    }
    // First popup after 15 seconds
    const initialTimeout = setTimeout(showNotification, 15000);
    // Then every 35-50 seconds
    const interval = setInterval(() => {
      showNotification();
    }, 35000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-382">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-4 z-[60] max-w-xs" data-id="element-383">
          <div className="bg-bg-card rounded-[20px] shadow-2xl border border-line p-4 flex items-start gap-3" data-id="element-384">
            <div className="w-10 h-10 bg-success/20 rounded-full flex items-center justify-center shrink-0" data-id="element-385">
              <ShoppingBag size={20} className="text-success" data-id="element-386" />
            </div>
            <div data-id="element-387">
              <p className="text-sm font-bold text-txt-primary" data-id="element-388">
                {data.name} de {data.city}
              </p>
              <p className="text-xs text-txt-body" data-id="element-389">
                compró{' '}
                <span className="font-bold text-brandOrange" data-id="element-390">
                  MEGAPACK Funcional 365
                </span>
              </p>
              <p className="text-xs text-txt-muted mt-1" data-id="element-391">
                hace {data.minutes} minutos
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-txt-muted hover:text-txt-primary text-xs ml-auto shrink-0 mt-0.5" data-id="element-392">
              ✕
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}